import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useRouter } from '@tanstack/react-router'
import { Request } from 'commons/utils/request'
import { Toast } from 'ui/components'
import { useConfirmation } from 'ui/components/Dialog/ConfirmationDialogV2'

import { TEMPLATES_LIST_KEY } from '../routes/TemplatesList/query'

export const useChangeTemplateStatus = () => {
  const confirmation = useConfirmation()
  const queryClient = useQueryClient()
  const router = useRouter()

  const { mutateAsync } = useMutation<void, Error, { id: number; active: boolean }>({
    mutationFn: ({ id, active }) =>
      active
        ? Request.put(Request.urls.bank.documentTemplateDeactivate, { id })
        : Request.put(Request.urls.bank.documentTemplateActivate, { id }),
    onSuccess: () => {
      router.invalidate()
      queryClient.invalidateQueries({ queryKey: [TEMPLATES_LIST_KEY] })
    },
    onError: (e) => {
      Toast.error(e.message)
    }
  })

  const openStatusChangeConfirmation = async ({ id, active }: { id: number; active: boolean }) =>
    await confirmation.showAskConfirmation({
      message: `Are you sure you want to ${active ? 'deactivate' : 'activate'} the Template ${id}? `,
      confirmCallback: () => mutateAsync({ id, active }),
      submitButtonText: active ? 'Deactivate' : 'Activate'
    })

  return {
    openStatusChangeConfirmation
  }
}
